import { ICountryInfo } from '@please.com/serverless-models/typedefs';
import removeAccents from 'remove-accents';
import { categoriesMap } from '../constants';
import { IService } from '../schemas/service';
import { IServiceGroup } from '../schemas/serviceGroup';
import { IServiceLocation } from '../schemas/serviceLocation';
import mathSansBoldMapping from '../services/math-sans-bold';
// tslint:disable-next-line: no-var-requires
const countries: ICountryInfo[] = require('@please.com/serverless-models/services/countries.json');

const servicePhrases = [
  (service: IService) => `Discounted ${getCategorySynonym(service)}`,
  (service: IService) => `Genuine ${getCategorySynonym(service)}`,
  (service: IService) => `Convenient ${getCategorySynonym(service)}`,
  (service: IService) => `Authentic ${getCategorySynonym(service)}`,
  (service: IService) => 'Guaranteed prices',
  (service: IService) => 'Discounted prices',
  (service: IService) => 'Bargains',
];

const tripPhrases = [
  'Insider travel to',
  'Authentic travel in',
  'Local secrets of',
  'Authentic trips by locals in',
  'Genuine trips by locals in',
  'Transparent pricing in',
  'Travel bargains in',
  'Insider secrets to',
  'Hidden gems of',
];

export function getServicePageTitle(service: IService) {
  if (!service.title) return '';
  const locationString = getLocationString(service, true);
  const index = getHash(service._id.toHexString()) % servicePhrases.length;
  const pagePhraseWithoutLocation = servicePhrases[index](service);
  const specialPhrase = convertToMathSansBold(
    `${pagePhraseWithoutLocation} ${locationString}`.trim(),
  );
  const titleSuffix = `⭐️ Always updated (${new Date().getFullYear()})`;
  const emoji = getCategoryEmoji(service);
  const serviceName = removeAccents(service.title.en || service.title['en-us'] || '');
  const pageTitle = `${serviceName} ${emoji} ${specialPhrase} ${titleSuffix}`.trim();
  return pageTitle;
}

export function getTripPageTitle(trip: IServiceGroup) {
  if (!trip.title) return '';
  const locationString = getLocationString(trip);
  const index = getHash(trip._id.toHexString()) % tripPhrases.length;
  const specialPhrase = convertToMathSansBold(`${tripPhrases[index]} ${locationString}`.trim());
  const titleSuffix = `⭐️ Always updated (${new Date().getFullYear()})`;
  const tripName = removeAccents(trip.title.en || trip.title['en-us'] || '');
  const pageTitle = `${tripName} 🗺️ ${specialPhrase} ${titleSuffix}`.trim();
  return pageTitle;
}

function getHash(id: string): number {
  const str = id;
  let hash = 7;
  for (let i = 0; i < str.length; i++) {
    hash = hash * 31 + str.charCodeAt(i);
  }
  return hash;
}

function getCategorySynonym(service: IService) {
  const { categories } = service;
  const category = categories && categories[0] && categories[0].names && categories[0].names.en;
  if (category === categoriesMap.accommodation) {
    // TODO: #165880891 use hostels, hotels, etc.
    return 'Hotels';
  }
  if (category === categoriesMap.food) return 'Restaurants';
  if (category === categoriesMap.activity) return 'Things to do';
}
function getCategoryEmoji(service: IService) {
  const { categories } = service;
  const category = categories && categories[0] && categories[0].names && categories[0].names.en;
  if (category === categoriesMap.accommodation) return '🛏️';
  if (category === categoriesMap.food) return '🍽';
  if (category === categoriesMap.activity) return '🎟';
  return '';
}

function getLocationString(tripOrService: { location?: IServiceLocation }, addPrefix = false) {
  const locationName = getLocation(tripOrService);
  if (locationName) return `${addPrefix ? 'in ' : ''}${locationName}`;
  return '';
}
function getLocation(tripOrService: { location?: IServiceLocation }) {
  const { location } = tripOrService;
  if (!location) return '';
  if (location.city) return location.city;
  if (location.state) return location.state;
  if (location.countryCode) {
    const countryObject = countries.find(country => country['alpha-2'] === location.countryCode);
    if (countryObject) return countryObject.name;
  }
  // TODO: #165880891 add continent as well
  return '';
}

function convertToMathSansBold(str: string) {
  const boldString = str
    .split('')
    .map(char => {
      // @ts-ignore
      return mathSansBoldMapping[char] || char;
    })
    .join('');
  return boldString;
}
